import { service } from '@ember/service';
import Component from '@glimmer/component';

import BasicDropdownWormhole from 'ember-basic-dropdown/components/basic-dropdown-wormhole';

function getHead() {
  return document.head;
}

export default class Application extends Component {
  // Services
  @service headData;

  // Template
  <template>
    {{#in-element (getHead) insertBefore=null}}
      <title>{{this.headData.title}}</title>
      <link rel='icon' type='image/svg+xml' href={{this.headData.favicon}} />
    {{/in-element}}
    <BasicDropdownWormhole />

    {{outlet}}
  </template>
}
